import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import { useEntitlements } from '../contexts/EntitlementsContext';
import { useLanguage } from '../contexts/LanguageContext';
import { hasPaidAccess } from '../entitlements';
import PlanComparison from '../components/PlanComparison';

export default function ProfilePlanCard({ user, onManage }) {
  const { entitlements, ready, error, refresh } = useEntitlements();
  const { language } = useLanguage();
  const copy = (en, ar) => language === 'ar' ? ar : en;
  const paid = hasPaidAccess(entitlements);
  const trial = !paid && entitlements?.scout?.trialActive && Number(entitlements.scout.trialEndsAt) > Date.now();
  return <section className="js-profile-v2__card js-profile-plan" aria-labelledby="profile-plan-title">
    <header className="js-profile-plan__header"><h2 id="profile-plan-title">{copy('Current plan', 'الخطة الحالية')}</h2>{ready && entitlements && !error && <strong className="js-profile-plan__name" dir="ltr">{paid ? 'Pro' : 'Free'}</strong>}</header>
    {!ready ? <p role="status">{copy('Loading your plan…', 'جارٍ تحميل خطتك…')}</p> : !entitlements || error ? <>
      <p role="alert">{copy('Could not load your plan.', 'تعذّر تحميل خطتك.')}</p>
      <button type="button" className="js-profile-plan__manage" onClick={() => refresh()}>{copy('Try again', 'حاول مجدداً')}</button>
    </> : <>
      {trial && <p className="js-profile-plan__trial">{copy('Scout trial active', 'تجربة مساعد البحث عن الوظائف مفعّلة')}</p>}
      <p>{paid
        ? copy('Your Pro tools are ready to use.', 'أدوات Pro جاهزة للاستخدام.')
        : copy('Find matching jobs, tailor your CV and reach hiring teams with Pro.', 'اعثر على وظائف تناسبك، وخصّص سيرتك الذاتية، وتواصل مع فرق التوظيف مع Pro.')}</p>
      <PlanComparison user={user} currentPlan={paid ? 'pro' : 'free'} className="js-profile-plan__compare">
        <span>{language === 'ar' ? <>قارن بين <bdi dir="ltr">Free</bdi> و <bdi dir="ltr">Pro</bdi></> : 'Compare Free and Pro'}</span><FiArrowRight className="js-profile-v2__forward" aria-hidden="true" />
      </PlanComparison>
      <button type="button" className="js-profile-plan__manage" onClick={onManage}>{copy('Plan & billing', 'الخطة والفوترة')}</button>
    </>}
  </section>;
}
